import React, { Component } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class Services2 extends Component {
  render() {
    var settings = {
      dots: true,
      arrows: true,
      speed: 3000,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const ClickHandler = () => {
      window.scrollTo(10, 0);
    };

    const service = [
      {
        sIcon: "fi flaticon-lamp",
        title: "Executive Search e Hunting",
        des: "Recrutamento ágil de líderes e executivos.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-edit",
        title: "Outplacement Individual e Coletivo",
        des: "Transição de carreira com suporte personalizado.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-startup",
        title: "Mentoria Executiva",
        des: "Desenvolvimento de competências para liderança.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-business",
        title: "Assessment de Competências",
        des: "Análise do potencial e performance profissional.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-trophy",
        title: "Mapeamento de Mercado Executivo",
        des: "Busca confidencial de talentos estratégicos.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-lamp",
        title: "Palestras, Treinamentos e Workshops",
        des: "Capacitação de equipes e desenvolvimento interno.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-edit",
        title: "Recolocação e Outplacement Profissional",
        des: "Apoio completo em recolocação no mercado.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-startup",
        title: "Gestão de Carreira Estratégica",
        des: "Planejamento e realinhamento de trajetórias.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-business",
        title: "Mentoria Executiva",
        des: "Direcionamento e fortalecimento de carreira.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-trophy",
        title: "Planejamento de Pós-Carreira",
        des: "Preparação para a próxima fase profissional.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-lamp",
        title: "Avaliação de Perfil Comportamental",
        des: "Identificação de perfil e potencial interno.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-edit",
        title: "Programa de Cargos e Salários",
        des: "Estruturação motivadora de carreiras organizacionais.",
        link: "#",
      },
      {
        sIcon: "fi flaticon-startup",
        title: "Pesquisa de Clima e Cultura",
        des: "Análise do ambiente e cultura organizacional.",
        link: "#",
      },
    ];

    return (
      <section
        className={`wpo-service-section section-padding ${this.props.srvClass}`}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="wpo-section-title">
                <span>Outros Serviços</span>
                <h2>Conheça nossos Serviços</h2>
              </div>
            </div>
          </div>
          <div className="wpo-service-items wpo-service-slider owl-carousel">
            <Slider {...settings}>
              {service.map((service, sitem) => (
                <div className="col-lg-4 col-md-6 col-12" key={sitem}>
                  <div className="wpo-service-item">
                    <div className="wpo-service-icon">
                      <div className="icon">
                        <i className={service.sIcon}></i>
                      </div>
                    </div>
                    <div className="wpo-service-text">
                      <h2>
                        <Link onClick={ClickHandler} to={service.link}>
                          {service.title}
                        </Link>
                      </h2>
                      <h3 className="fs-4 fw-light">{service.des}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

export default Services2;
